import ApiUsageModal from "../../Components/ApiUsageModal.jsx";
import BulletinBoardSlider from "../../Components/BulletinBoardSlider.jsx";
import KeyGenerateModal from "../../Components/KeyGenerateModal.jsx";
import SimpleFooter from "../../Components/SimpleFooter.jsx";
import SubscriptionBilling from "../../Components/SubscriptionBilling.jsx";
import DashboardWeatherOverview from "../../Components/DashboardWeatherOverview.jsx";
import SevenDayForecastAccordion from "../../Components/SevenDayForecastAccordion.jsx";
import useDashboardHome from "./useDashboardHome.js";
import useDashboardWeather from "./useDashboardWeather.js";
import { useWeatherLocation } from "../../contexts/WeatherLocationContext.jsx";

export default function DashboardHome() {
  const {
    setShowKeyModal,
    showKeyModal,
    selectedApikey,
    latestBulletins,
    setSelecetdApiKey,
    currentSubscription,
  } = useDashboardHome();

  const {
    activeLocation,
    isLive: isCurrentLocation,
    isDefault: isDefaultLocation,
    loading: locationLoading,
    activateCurrentLocation,
  } = useWeatherLocation();

  const {
    current,
    place,
    hourlyWindMph,
    tempHighF,
    tempLowF,
    sunrise,
    sunset,
    sunTimeZone,
    sunriseIso,
    sunsetIso,
    narrative,
    dailyForecastRaw,
    weekMinF,
    weekMaxF,
    loading: weatherLoading,
    error: weatherError,
    refetch: refetchWeather,
  } = useDashboardWeather(activeLocation);

  const handleActivateLocation = activateCurrentLocation;

  const getWeatherIconUrl = (icon) =>
    require(`../../assets/weatherIocns/${icon}.png`);

  return (
    <>
      <div className="space-y-6 px-3 py-4 sm:space-y-8 sm:px-4">
        <DashboardWeatherOverview
          current={current}
          place={place}
          hourlyWindMph={hourlyWindMph}
          tempHighF={tempHighF}
          tempLowF={tempLowF}
          sunrise={sunrise}
          sunset={sunset}
          sunTimeZone={sunTimeZone}
          sunriseIso={sunriseIso}
          sunsetIso={sunsetIso}
          narrative={narrative}
          loading={weatherLoading || locationLoading}
          error={weatherError}
          getCurrentLocation={handleActivateLocation}
          isCurrentLocation={isCurrentLocation}
          isDefaultLocation={isDefaultLocation}
          getWeatherIconUrl={getWeatherIconUrl}
          refetchWeather={refetchWeather}
        />

        <SevenDayForecastAccordion
          dailyForecastRaw={dailyForecastRaw}
          loading={weatherLoading || locationLoading}
          getWeatherIconUrl={getWeatherIconUrl}
        />

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-12 lg:gap-5">
          <div className="min-w-0 h-full lg:col-span-7">
            <SubscriptionBilling
              isAdminCreated={currentSubscription?.isCustomAssignedByAdmin}
            />
          </div>
          <div className="min-w-0 h-full lg:col-span-5">
            <BulletinBoardSlider bulletins={latestBulletins} />
          </div>
        </div>
      </div>

      <KeyGenerateModal
        open={showKeyModal}
        onClose={() => setShowKeyModal(false)}
      />
      <ApiUsageModal
        isOpen={!!selectedApikey}
        onClose={() => setSelecetdApiKey(null)}
        data={selectedApikey}
      />
      <SimpleFooter />
    </>
  );
}
